/* eslint-disable */
import Vue from "vue";
import Router from "vue-router";
// import vue file here
import LiveNewv2 from "../pages/LiveNewV2.vue";
import VodNew from "../pages/VodNew.vue";
// import RadioNEW from "../pages/RadioNew.vue";
import RadioList from "../pages/RadioList.vue";
import RadioPlayer from "../pages/RadioPlayerv1.vue";
import Disclaimer from "../pages/Disclaimer.vue";
import Privacy from "../pages/Privacy.vue";
// import SpecialsPlayer from "../pages/SpecialsPlayer.vue";
import Search from "../pages/Search.vue";
import Viewall from "../pages/view_all.vue";
import Player from "../pages/Player.vue";
import Login from "../pages/Login.vue";
import Registration from "../pages/Register.vue";
import ForgetPassword from "../pages/ForgetPassword.vue";
import PasswordToken from "../pages/PasswordToken.vue";
import ResetPassword from "../pages/ResetPassword.vue";
import Profile from "../pages/Profile.vue";
// new revamp ui link
import HomeNew from "../pages/HomeNew.vue";
import Penafian from "../pages/Penafian.vue";
import DasarPrivasi from "../pages/DasarPrivasi.vue";
import LatarBelakang from "../pages/LatarBelakang.vue";
import DasarKeselamatan from "../pages/DasarKeselamatan.vue";
import SoalanLazim from "../pages/SoalanLazim.vue";
import EpgTV from "../pages/EpgTv.vue";
import EpgRadio from "../pages/EpgRadio.vue";
import News from "../pages/News";
import FavoriteViewAll from "../pages/Favorite.vue";
import store from "../plugins/store/store";

Vue.use(Router);

const router = new Router({
  // linkActiveClass: "is-active", // active class for non-exact links.
  // linkExactActiveClass: "is-active", // active class for *exact* links.
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/",
      name: "home_new",
      component: HomeNew,
    },
    {
      path: "/live/:id?",
      name: "LiveNewv2",
      component: LiveNewv2,
    },
    {
      path: "/login/:code?",
      name: "login",
      component: Login,
      meta: {
        hideForAuth: true,
      },
    },
    {
      path: "/register/:code?",
      name: "Registration",
      component: Registration,
      meta: {
        hideForAuth: true,
      },
    },
    {
      path: "/forget-password",
      name: "ForgetPassword",
      component: ForgetPassword,
    },
    {
      path: "/reset",
      name: "ResetPassword",
      component: ResetPassword,
    },
    {
      path: "/password/:token",
      name: "PasswordToken",
      component: PasswordToken,
    },
    {
      path: "/profile",
      name: "Profile",
      component: Profile,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/radiolist",
      name: "radiolist",
      component: RadioList,
    },
    {
      // type : nasional,negeri,tempatan
      path: "/radio/:type/:id?",
      name: "radio_player",
      component: RadioPlayer,
    },
    {
      path: "/disclaimer",
      name: "disclaimer",
      component: Disclaimer,
    },
    {
      path: "/privacy",
      name: "privacy",
      component: Privacy,
    },
    {
      path: "/vod",
      name: "vod",
      component: VodNew,
    },
    {
      path: "/berita",
      name: "berita",
      component: News,
    },
    {
      // s -> for source(vod,special or news)
      // p_type -> player type true -> playlist or pe -> single
      path: "/play/:type/:program_id/:episode_id?",
      name: "player",
      component: Player,
    },
    {
      path: "/search",
      name: "Search",
      component: Search,
    },
    {
      path: "/viewall/:type/:id",
      name: "viewall",
      component: Viewall,
    },
    {
      path: "/favorite",
      name: "favorite",
      component: FavoriteViewAll,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/penafian",
      name: "Penafian",
      component: Penafian,
    },
    {
      path: "/dasar-privasi",
      name: "DasarPrivasi",
      component: DasarPrivasi,
    },
    {
      path: "/latar-belakang",
      name: "LatarBelakang",
      component: LatarBelakang,
    },
    {
      path: "/dasar-keselamatan",
      name: "DasarKeselamatan",
      component: DasarKeselamatan,
    },
    {
      path: "/soalan-lazim/:lang?",
      name: "SoalanLazim",
      component: SoalanLazim,
    },
    {
      path: "/epg-tv",
      name: "EpgTV",
      component: EpgTV,
    },
    {
      path: "/epg-radio",
      name: "EpgRadio",
      component: EpgRadio,
    },
  ],
});

router.beforeResolve((to, from, next) => {
  // If this isn't an initial page load.
  if (to.name) {
    // Start the route progress bar.
    // NProgress.start();
  }
  next();
});

router.beforeEach((to, from, next) => {
  let token = localStorage.getItem("token");
  let isLoggedIn = token ? true : false;

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!isLoggedIn) {
      next({ path: "/login" });
    } else {
      next();
    }
  } else {
    next();
  }

  if (to.matched.some((record) => record.meta.hideForAuth)) {
    if (isLoggedIn) {
      next({ path: "/" });
    } else {
      next();
    }
  } else {
    next();
  }
});

router.afterEach((to, from) => {
  // Complete the animation of the route progress bar.
  // NProgress.done();
});

export default router;
